<template>
  <div class="package-editor">
    <div class="row">
      <div class="col image-container">
        <label class="label">รูปปก</label>
        <img :src="thumbnailUrl" class="thumbnail" />
        <sc-button
          v-if="!disabled"
          class="thumbnail-button"
          @click="handleClickChooseImageButton"
          >เลือกรูปปก</sc-button
        >
      </div>
      <div class="col info-editor">
        <label class="label">ชื่อ</label>
        <el-input
          :disabled="disabled"
          :value="name"
          class="input"
          @input="handleChangeInput('name', $event)"
        ></el-input>
        <label class="label">รายการแพ็กเกจ</label>
        <package-selector
          :value="packages"
          :disabled="disabled"
          class="input"
          @input="handleChangeInput('packages', $event)"
          @isLoading="handleIsLoading"
        ></package-selector>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import PackageSelector from "./PackageSelector";

export default {
  components: {
    ScButton,
    ImagePickerModal,
    PackageSelector,
    "el-input": Input
  },
  props: {
    value: { type: Object, default: () => ({}) },
    imageUrl: { type: String, default: "" },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      isShowModal: false
    };
  },
  computed: {
    name() {
      return this.value.name;
    },
    packages() {
      return this.value.packages;
    },
    thumbnailUrl() {
      if (!this.chooseImageDialog.thumbnailUrl) {
        return "https://placehold.co/1200x900";
      }

      return this.chooseImageDialog.thumbnailUrl;
    },
    targetId() {
      if (!this.value.target) {
        return null;
      }

      return this.value.target.id;
    },
    targetOptions() {
      return this.targets;
    },
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูปปกแพ็กเกจ",
        width: 300,
        height: 200,
        recommendWidth: 1200,
        recommendHeight: 900,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.imageUrl
      };
    }
  },
  methods: {
    handleChangeInput(key, value) {
      const isNumber = key === "price" || key === "billingCycle";
      this.$emit("input", { ...this.value, [key]: isNumber ? +value : value });
    },
    handleClickChooseImageButton() {
      this.showChooseImageDialog();
    },
    handleCancelChooseImageDialog() {
      this.hideChooseImageDialog();
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, imageFile: file });
      this.hideChooseImageDialog();
    },
    showChooseImageDialog() {
      this.isShowModal = true;
    },
    hideChooseImageDialog() {
      this.isShowModal = false;
    },
    handleChangeTarget(targetId) {
      const target = this.targets.find(t => t.id === targetId);

      this.$emit("input", { ...this.value, target });
    },
    handleIsLoading(isLoading) {
      this.$emit("isLoading", isLoading);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}
</style>
